import { Injectable, inject } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { EligibilityEventOfferingEnriched, EligibilityEventOfferingState } from '@models/profileConfiguration/model';
import { Observable } from 'rxjs';
import { filter, map, switchMap } from 'rxjs';
import { EligibilityEventOfferingStore, EligibilityEventOfferingStoreState } from './eligibility-event-offering.store';

@Injectable({
  providedIn: 'root',
})
export class EligibilityEventOfferingQuery extends QueryEntity<EligibilityEventOfferingStoreState> {
  protected store: EligibilityEventOfferingStore;

  constructor() {
    const store = inject(EligibilityEventOfferingStore);

    super(store);

    this.store = store;
  }

  public selectAllWhenLoaded(): Observable<EligibilityEventOfferingEnriched[]> {
    return this.selectLoading().pipe(
      filter((isLoading) => !isLoading),
      switchMap(() => this.selectAll())
    );
  }

  public selectByStateWhenLoaded(states: EligibilityEventOfferingState[]): Observable<EligibilityEventOfferingEnriched[]> {
    return this.selectAllWhenLoaded().pipe(map((eligibilityEventOfferings) => eligibilityEventOfferings.filter((eeo) => states.includes(eeo.currentState as EligibilityEventOfferingState))));
  }

  public selectByState(states: EligibilityEventOfferingState[]): Observable<EligibilityEventOfferingEnriched[]> {
    return this.selectAll().pipe(map((eligibilityEventOfferings) => eligibilityEventOfferings.filter((eeo) => states.includes(eeo.currentState as EligibilityEventOfferingState))));
  }

  public selectByEvent(eventId: string): Observable<EligibilityEventOfferingEnriched[]> {
    return this.selectAllWhenLoaded().pipe(map((offerings) => offerings.filter((o) => o.parentId === eventId)));
  }
}
